import FallbackLoader from './FallbackLoader';

export default FallbackLoader;
